export const INHERENT_RISK_PROFILE_LABEL = {
  HEADING: 'Inherent Risk Profile',
  VALIDATE_INHERENT_RISK: 'Validate inherent risk',
  EDIT: 'Edit',
  VIEW_DETAILS: 'View Details',
  ESTIMATING_INHERENT_RISK: 'Estimating inherent risk',
  ESTIMATED_BADGE_TOOLTIP: 'Estimated by Lema, not yet validated.',
  ESTIMATED_BADGE_TOOLTIP_CTA_PREFIX: 'To review and confirm it,',
  ESTIMATED_BADGE_TOOLTIP_CTA_SUFFIX: 'click "Validate inherent risk".',
  OUTDATED_QUESTIONNAIRE_ALERT:
    'This risk score is based on a previous questionnaire version. Editing will reset responses',
} as const
